import {EnvBankPostDataTransferObject} from "../../data-transfer-object/env/EnvBankPostDataTransferObject"

/**
 * 은행 속성 설명
 */
export const EnvBankPostDataTransferObjectDescription: Record<keyof EnvBankPostDataTransferObject, string> = {
    name: '이름',
    displayOrder: '표시 우선 순위'
}
